import React from 'react'
import styles from './ScoutOfferPattern.module.css'
import { ScoutOfferPatternProps } from './types'
import { useAbTestGtm } from '@/components/utils/abTest'
import { CtaButton } from './CtaButton'

const IMAGE_DIR = '/pages/abtest/dev3392'

// DEV-3392 Cパターン: 登録が続いているように見せ（次のステップ）、自然にPF転換へ誘導する。
// オファー終了日時は出さないデザインのため expiredDate は使わない。
export const ScoutOfferC = ({ telImageSrc, upgradeUrl }: ScoutOfferPatternProps) => {
    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.body}>
            <img
                src={`${IMAGE_DIR}/c_head.png`}
                alt='ご登録ありがとうございます！今すぐ転職を考えていない場合は、ご相談だけでも歓迎！'
                className={styles.strip}
            />
            <div className={styles.telRowCD}>
                <img src={telImageSrc} alt='TEL画像' className={styles.telImage} />
            </div>
            <div data-view-label={dataViewLabel('Thanks_CT_スカウト')}>
                <div data-view-label={dataViewLabel('Thanks_CT_スカウト_コンテンツ1')}>
                    <img
                        src={`${IMAGE_DIR}/c_step.png`}
                        alt='次のステップ：STEP1 会員登録完了、STEP2 プロフィール登録、STEP3 転職開始'
                        className={styles.strip}
                    />
                </div>
                <CtaButton
                    bgSrc={`${IMAGE_DIR}/c_cta1_bg.png`}
                    bgWidth={750}
                    bgHeight={182}
                    button={{ x: 75, y: 62, w: 600, h: 104 }}
                    shape='pill'
                    text='プロフィール登録へ進む'
                    href={upgradeUrl}
                    dataClickLabel={dataClickLabel('Thanks_CT_スカウト_CTAボタン1')}
                    badge={{ box: { x: 175, y: 12, w: 400, h: 62 }, text: '今なら3日間限定特典あり！' }}
                />
                <img
                    src={`${IMAGE_DIR}/c_benefit.png`}
                    alt='プロフィール登録でできること：スカウトが届く、求人が保存できる、求人のレコメンド'
                    className={styles.strip}
                />
                <div data-view-label={dataViewLabel('Thanks_CT_スカウト_コンテンツ2')}>
                    <img
                        src={`${IMAGE_DIR}/c_benefit4.png`}
                        alt='ワンクリックでかんたん応募'
                        className={styles.strip}
                    />
                </div>
                <CtaButton
                    bgSrc={`${IMAGE_DIR}/c_cta2_bg.png`}
                    bgWidth={750}
                    bgHeight={182}
                    button={{ x: 75, y: 66, w: 600, h: 104 }}
                    shape='pill'
                    text='プロフィール登録へ進む'
                    href={upgradeUrl}
                    dataClickLabel={dataClickLabel('Thanks_CT_スカウト_CTAボタン2')}
                    badge={{ box: { x: 111, y: 16, w: 526, h: 62 }, text: 'あと2分で全ての機能が使えるようになります' }}
                />
                <img src={`${IMAGE_DIR}/c_tail.png`} alt='' className={styles.strip} />
            </div>
        </div>
    )
}

export default ScoutOfferC
